import React from "react";
import {
  Checkbox,
  IconButton,
  SearchField,
  SelectField,
} from "@tiny/components";
import MoreHorizontal from "@tiny/icons/generated/MoreHorizontal";
import ChipWithTooltip from "@tiny/components/src/ChipWithTooltip/ChipWithTooltip";
import { useSearchPanelHeader } from "./SearchPanelHeader.hooks";
import { useStyles } from "./SearchPanelHeader.styles";

function SearchPanelHeader() {
  const {
    HeaderComponent,
    MoreDialogComponent,
    allSelected,
    allSelectedDisabled,
    data,
    onDeselectAll,
    onSearch,
    onSort,
    onTagDelete,
    onToggleSelectAll,
    openMore,
    search,
    selectable,
    selectedCount,
    shouldShowSearch,
    sort,
    sortOptions,
    sortWidth,
    tags,
  } = useSearchPanelHeader();

  const classes = useStyles({ sortWidth });

  return (
    <div className={classes.root}>
      <div className={classes.wrap}>
        {selectable && (
          <div className={classes.check}>
            <Checkbox
              color="primary"
              checked={allSelected}
              onChangeValue={(checked) => onToggleSelectAll(data, checked)}
              disabled={allSelectedDisabled}
              title="Select all"
            />
          </div>
        )}
        {shouldShowSearch && (
          <div className={classes.search}>
            <SearchField
              value={search}
              placeholder="Search"
              onChangeValue={onSearch}
              fullWidth
            />
          </div>
        )}
        <div className={classes.actions}>
          <HeaderComponent
            selectedCount={selectedCount}
            onDeselectAll={onDeselectAll}
          />
        </div>
        {sortOptions && (
          <div className={classes.sort}>
            <SelectField
              options={sortOptions}
              value={sort}
              onChangeValue={onSort}
              aria-label="Sort"
            />
          </div>
        )}
        {MoreDialogComponent && (
          <div className={classes.more}>
            <IconButton onClick={openMore} size="small" aria-label="More">
              <MoreHorizontal />
            </IconButton>
          </div>
        )}
      </div>
      {tags && tags.length > 0 && (
        <div className={classes.tags}>
          {tags.map((tag) => (
            <ChipWithTooltip
              key={tag.id}
              label={tag.name}
              color="grey"
              onDelete={() => onTagDelete?.(tag)}
              maxVisibleChars={16}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchPanelHeader;
